<template>
	<nk-box
		v-if="typeof context !== 'undefined' && context.length > 0"
		variant="sidebar"
	>
		<nk-title size="lg">Veranstaltungen</nk-title>

		<nk-row vertical-gutter="3">
			<nk-col
				v-for="(veranstaltung, index) in context.slice(0, 3)"
				:key="index"
				cols="full"
			>
				<nk-link
					v-if="getDetailURL(veranstaltung.rubriken)"
					:link="getDetailURL(veranstaltung.rubriken)"
				>
					<nk-meta size="md" variant="normal" no-margin>
						{{ veranstaltung.titel }}
					</nk-meta>
				</nk-link>
				<nk-meta v-else size="md" variant="normal" no-margin>
					{{ veranstaltung.titel }}
				</nk-meta>
				<nk-meta>
					<nk-icon icon="date" class="mr-1" />
					{{ getDateTimeString(veranstaltung.datum_von) }}
				</nk-meta>
			</nk-col>
		</nk-row>
	</nk-box>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

/**
 * @prop {object} context
 */
export default {
	name: 'NkSidebarBrancheneintragVeranstaltungen',

	mixins: [TemplatesDefault],

	methods: {
		getDateTimeString(object) {
			return this.$formatTime(object);
		},
		getDetailURL(rubriken) {
			if (rubriken.length && rubriken[0].detailURL) {
				return rubriken[0].detailURL;
			}

			return '';
		},
	},
};
</script>
